import React, { useState, useEffect } from "react";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "../../css/AuthModal.css";

interface Props {
	show: boolean;
	onClose: () => void;
}

const AuthModal: React.FC<Props> = ({ show, onClose }) => {
	const [isLogin, setIsLogin] = useState(true);

	useEffect(() => {
		if (show) {
			setIsLogin(true);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
	}, [show]);

	if (!show) return null;

	const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<div className="auth-modal-overlay" onClick={handleOverlayClick}>
			<div className="auth-modal">
				<FontAwesomeIcon icon={faXmark} onClick={onClose} className="close-btn" />
				{isLogin ? <LoginForm onSuccess={onClose} /> : <RegisterForm onSuccess={onClose} />}
				<p className="toggle-text">
					{isLogin ? "¿No tienes cuenta?" : "¿Ya tienes cuenta?"}{" "}
					<span onClick={() => setIsLogin(!isLogin)}>
						{isLogin ? "Regístrate" : "Inicia sesión"}
					</span>
				</p>
			</div>
		</div>
	);
};

export default AuthModal;
